import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const WishlistContext = createContext(null);

export const useWishlist = () => useContext(WishlistContext);

export const WishlistProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("aarmira_wishlist")) || [];
    } catch {
      return [];
    }
  });
  const [email, setEmail] = useState(() => localStorage.getItem("aarmira_wishlist_email") || "");
  const [pendingProduct, setPendingProduct] = useState(null);

  useEffect(() => {
    localStorage.setItem("aarmira_wishlist", JSON.stringify(items));
  }, [items]);

  const has = (id) => items.some((p) => p.id === id);

  const subscribe = async (productId, addr) => {
    if (!addr) return;
    try {
      await api.post("/wishlist/subscribe", { email: addr, product_id: productId });
    } catch {}
  };

  const toggle = (product) => {
    const adding = !items.some((p) => p.id === product.id);
    setItems((prev) =>
      prev.some((p) => p.id === product.id)
        ? prev.filter((p) => p.id !== product.id)
        : [...prev, product]
    );
    if (adding) {
      if (email) {
        subscribe(product.id, email);
      } else {
        setPendingProduct(product);
      }
    }
  };

  const remove = (id) => setItems((prev) => prev.filter((p) => p.id !== id));

  const saveEmail = (addr) => {
    const clean = addr.trim().toLowerCase();
    setEmail(clean);
    localStorage.setItem("aarmira_wishlist_email", clean);
    if (pendingProduct) {
      subscribe(pendingProduct.id, clean);
    }
    setPendingProduct(null);
  };

  return (
    <WishlistContext.Provider
      value={{
        items,
        has,
        toggle,
        remove,
        count: items.length,
        email,
        pendingProduct,
        setPendingProduct,
        saveEmail,
      }}
    >
      {children}
    </WishlistContext.Provider>
  );
};
